/**
 * @generated SignedSource<<2b7e1dcbc4877bed9a613fdf29547c4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerSectionTopHomeV2QueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly name?: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly " $fragmentType": "headerSectionTopHomeV2QueueItemsEdge";
}>;
export type headerSectionTopHomeV2QueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: headerSectionTopHomeV2QueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "headerSectionTopHomeV2QueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entityLink"
            }
          ],
          "type": "Section",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "3d0a423a2c3e7a547e85281c16c3bcc3";

export default node;
